/*
 * @Description:
 * @Date: 2019-07-31 16:06:30
 */
import '@babel/polyfill';
import Vue from 'vue';
import App from './App';
import store from './store/index.js';
import router from './router/index';
import pluginIndex from './plugins/index.js';
import './router/guide';
import { sync } from 'vuex-router-sync';
import '@/filters/index';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/element-variables.scss';
import './assets/css/reset.css';
import './assets/icon/iconfont.css';
import './assets/css/common.css';
import Config from '@/config/index';
import Xrk from 'xrk-components';
import XrkSubtitle from '@C/XrkSubtitle';
import './qiankun'; // qiankun: 主文件
require('./icons/index.js');

document.domain = Config.domain;
sync(store, router);
// Vue.use(configElement)
Vue.use(Element);
Vue.use(Xrk);
// Vue.use(vueRegister)
Vue.use(pluginIndex);
Vue.prototype.$updateVersion();
Vue.prototype.$sa.init();
// Vue.use(RouterGuide)
Vue.config.productionTip = false;
Vue.component('xrk-subtitle', XrkSubtitle);
/* eslint-disable no-new */

export const instance = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
